module.exports = __webpack_public_path__ + "img/inactive-list.4851e595.svg";